module.exports = __webpack_public_path__ + "img/editar-icon.02b07173.svg";